import { useState, useEffect, useRef } from 'react';
import { getTpVastsDoc } from '../../api/tpVasts';
import { TPVAST_CONSTANTS } from '../../core/constants';

const useTpVastDoc = (siteId) => {
	const [tpVastDoc, setTpVastDoc] = useState({});
	const [tpVastDocEditMode, setTpVastDocEditMode] = useState('');
	const { FLOOR, DEMAND, PLATFORM } = TPVAST_CONSTANTS.INVENTORY;
	const [selectedTpValues, setSelectedTpValues] = useState({
		[FLOOR]: '',
		[DEMAND]: '',
		[PLATFORM]: ''
	});

	/**
	 * @name updateSelectedTpValues The function `updateSelectedTpValues` set the selectedTpValues according to params
	 * @param {String} key - Inventory type for ex:- floor, demand or platform.
	 * @param {String} value -  value for that inventory type.
	 */
	const updateSelectedTpValues = (key, value) => {
		const prevData = structuredClone(selectedTpValues);
		let newData;
		switch (key) {
			case FLOOR:
				newData = { ...prevData, [FLOOR]: value, [DEMAND]: '', [PLATFORM]: '' };
				break;
			case DEMAND:
				newData = { ...prevData, [DEMAND]: value, [PLATFORM]: '' };
				break;
			case PLATFORM:
				newData = { ...prevData, [PLATFORM]: value };
				break;
			default:
				newData = { ...prevData };
		}
		setSelectedTpValues(newData);
	};
	const previousTpVastDoc = useRef({});
	useEffect(() => {
		(async function () {
			if (siteId && Object.keys(tpVastDoc).length === 0) {
				try {
					const { data } = await getTpVastsDoc(siteId);
					const tpVastUnits = data.data.tpVastsDoc;
					const clonedTpVastUnits = structuredClone(tpVastUnits);
					setTpVastDoc(clonedTpVastUnits);
					setTpVastDocEditMode(TPVAST_CONSTANTS.EDIT_MODES.UPDATE);
					previousTpVastDoc.current = tpVastUnits;
				} catch (error) {
					console.log('Error fetching TpVast Doc', error);
					setTpVastDocEditMode(TPVAST_CONSTANTS.EDIT_MODES.CREATE);
				}
			}
		})();
	}, [siteId]);

	return {
		tpVastDoc,
		updateTpVastDoc: setTpVastDoc,
		selectedTpValues,
		setSelectedTpValues,
		updateSelectedTpValues,
		tpVastDocEditMode,
		setTpVastDocEditMode,
		previousTpVastDoc
	};
};

export default useTpVastDoc;
